import { render, staticRenderFns } from "./MergeContact.vue?vue&type=template&id=5a122fcb&scoped=true&"
import script from "./MergeContact.vue?vue&type=script&lang=js&"
export * from "./MergeContact.vue?vue&type=script&lang=js&"
import style0 from "./MergeContact.vue?vue&type=style&index=0&id=5a122fcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a122fcb",
  null
  
)

export default component.exports